@if (loadType() === 'LOADING' && loadingText()) {
    <span class="text-gray-6 fw-medium text-italic fade-animation">{{ loadingText() }}</span>
}
@if (loadType() === 'STREAM' && streamText()) {
    <p class="fs-3">{{ streamText() }}</p>
}
@if (loadType() === 'NONE' && inputText()) {
    <p class="fs-3">{{ inputText() }}</p>
}
